const removeFalsyValues = (obj: any) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
        if (
            String(obj[key]) === 'null' ||
            String(obj[key]) === 'undefined' ||
            obj[key] === -1 ||
            String(obj[key]) === ''
        ) {
            // eslint-disable-next-line no-param-reassign
            delete obj[key];
        }
    }
    return obj;
};

export default removeFalsyValues;
